import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import { EProducts } from '../../model/enums';
import PageTitle from '../../shared/PageTitle/PageTitle';
import { $productsState } from '../../store/models/products';
import ProductItem from '../../components/ui/ProductItem/ProductItem';
import { fetchGetAllProductsFx } from '../../store/models/products/effects';

import styles from './styles.module.scss';

const ProductsPage = () => {
  const { t } = useTranslation();
  const { grasses, accessories, catnips, catGrassSeeds } = useUnit($productsState);

  useEffect(() => {
    fetchGetAllProductsFx();
  }, []);

  return (
    <div className={styles.productsPage}>
      <div className="container">
        <PageTitle weight="normal">{t('products')}</PageTitle>
        <div className={styles.productsWrapper}>
          {grasses.map((grassData, ix) => {
            return <ProductItem key={ix} productData={grassData} productType={EProducts.grs} />;
          })}
          {accessories.map((accessoryData, ix) => {
            return <ProductItem key={ix} productData={accessoryData} productType={EProducts.acs} />;
          })}
          {catnips.map((catnipData, ix) => {
            return <ProductItem key={ix} productData={catnipData} productType={EProducts.ctn} />;
          })}
          {catGrassSeeds.map((catGrassSeed, ix) => {
            return <ProductItem key={ix} productData={catGrassSeed} productType={EProducts.sds} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;
